





































































import { Component, Vue } from "vue-property-decorator";

/**
 * Utils
 */
import { teamUrl } from "@/utils/url-helpers";

/**
 * Mixins
 */
/**
 * Components
 */
import draggable from "vuedraggable";
import TeamCard from "./components/TeamCard.vue";
import CreateTeamDialog from "./components/CreateTeamDialog.vue";
import LeaveTeamDialog from "./components/LeaveTeamDialog.vue";

/**
 * API
 */
import teamsAPI from "@/api/teams";
import usersAPI from "@/api/users";
import DataFetcher from "@/components/_global/DataFetcher.vue";
import { GetTeamsResponse } from "@/api/teams/get-teams.response";


/**
 * Types
 */

/**
 * VueX Modules
 */


@Component({
	components: {
		DataFetcher,
		draggable,
		TeamCard,
		CreateTeamDialog,
		LeaveTeamDialog
	}
})
export default class TeamsListPage extends Vue {
	$refs!: {
		createTeamDialog: CreateTeamDialog;
		leaveTeamDialog: LeaveTeamDialog;
	};
	/// Injections
	teamUrl = teamUrl;

	/// Attributes
	isLoading = false;
	teamsICanEnter: GetTeamsResponse.Team[] | null = null;
	isDragging = false;


	// This will check if the screen size is small and if the device supports touch
	get isTouchDevice() {
		return this.isMobile && this.hasTouch;
	}

	// Check if the screen size is small (mobile mode)
	get isMobile() {
		return this.$vuetify.breakpoint.smAndDown;
	}

	// Check if the device has touch capabilities
	get hasTouch() {
		return "ontouchstart" in window || navigator.maxTouchPoints > 0;
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchGuilds();
	}

	async fetchGuilds() {
		this.teamsICanEnter = await teamsAPI.getTeams();
	}

	handleOpenLeaveTeamClick(team: any) {
		this.$refs.leaveTeamDialog.open(team);
	}

	async handleOpenCreateTeamClick() {
		await this.$refs.createTeamDialog.open();
	}

	async handleAfterCreateTeam() {
		await this.fetchGuilds();
	}

	async handleAfterLeaveTeam() {
		await this.fetchGuilds();
		await this.$team.fetch(null);
	}

	async handleDragEnd(evt: any) {
		const oldIndex = evt.oldIndex;
		const newIndex = evt.newIndex;
		if (oldIndex == newIndex) {
			return;
		}

		if (this.teamsICanEnter == null) {
			return;
		}

		const teamToMove = this.teamsICanEnter[newIndex];
		const newPosition = newIndex + 1;

		this.isDragging = false;

		this.isLoading = true;
		try {
			await usersAPI.changeTeamOrder(teamToMove.id, newPosition);
		} catch (error) {
			this.handleAPIError(error);
		}

		await this.fetchGuilds();


		this.isLoading = false;
	}
}
